var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGenerativeAi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0253 4.20847C16.948 3.99952 16.6524 3.99952 16.5751 4.20847L16.2108 5.19288C15.9678 5.84981 15.4498 6.36775 14.7929 6.61084L13.8085 6.9751C13.5995 7.05242 13.5995 7.34795 13.8085 7.42527L14.7929 7.78954C15.4498 8.03262 15.9678 8.55057 16.2108 9.20749L16.5751 10.1919C16.6524 10.4009 16.948 10.4009 17.0253 10.1919L17.3895 9.20749C17.6326 8.55057 18.1506 8.03262 18.8075 7.78954L19.7919 7.42527C20.0009 7.34795 20.0009 7.05242 19.7919 6.9751L18.8075 6.61084C18.1506 6.36775 17.6326 5.84981 17.3895 5.19288L17.0253 4.20847ZM11.0253 6.60847C10.948 6.39952 10.6524 6.39952 10.5751 6.60847L9.23851 10.2206C8.99543 10.8775 8.47748 11.3954 7.82056 11.6385L4.20847 12.9751C3.99952 13.0524 3.99952 13.348 4.20847 13.4253L7.82055 14.7619C8.47748 15.0049 8.99543 15.5229 9.23851 16.1798L10.5751 19.7919C10.6524 20.0009 10.948 20.0009 11.0253 19.7919L12.3619 16.1798C12.6049 15.5229 13.1229 15.0049 13.7798 14.7619L17.3919 13.4253C17.6009 13.348 17.6009 13.0524 17.3919 12.9751L13.7798 11.6385C13.1229 11.3954 12.6049 10.8775 12.3619 10.2206L11.0253 6.60847Z",
    fill: "url(#paint0_linear_21_14621)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21_14621",
    x1: 17.2017,
    y1: 14.1198,
    x2: 6.02302,
    y2: 14.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5FDD8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.952317,
    stopColor: "#2B94FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerativeAi);
export default __webpack_public_path__ + "static/media/GenerativeAI.4598729f2353dc5a52c786e6c47f1efe.svg";
export { ForwardRef as ReactComponent };